import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductProvider } from "~/contexts/ProductContext";
import { ProductDetails } from "~/pages/ProductDetails/ProductDetails";

export const Route = createFileRoute("/_app/books/$productId")({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.book") }] }),
  component: BookRoute,
});

function BookRoute() {
  const { productId } = Route.useParams();

  return (
    <ProductProvider id={productId}>
      <ProductDetails />
    </ProductProvider>
  );
}
